import type { RouteParams } from './RouteParams';
import type { RouteName } from './Router';

export class Route {
    /**
     * The name of the route
     */
    public readonly name: RouteName;

    /**
     * The parameters of the route
     */
    public readonly params?: RouteParams;

    /**
     * The actual parsed href of the route
     */
    public readonly href: string;

    /**
     * The hash of the route
     */
    public readonly hash?: string;

    /**
     * The constructor for the route
     * @param name The name of the route
     * @param params The parameters of the route
     */
    public constructor(name: RouteName, href: string, params?: RouteParams) {
        this.name = name;
        this.params = params;
        this.href = href;
    }
}
